
import App from '@/components/App.vue'
import "@/globals/filters";

import {library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {fal} from '@fortawesome/pro-light-svg-icons'
import {far} from '@fortawesome/pro-regular-svg-icons'
import {fas} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import ButtonWidget from '@payroll/button-widget/src/ButtonWidget.vue'
import CheckboxWidget from '@payroll/checkbox-widget/src/CheckboxWidget.vue'
import DateFieldWidget from '@payroll/date-field-widget/src/DateFieldWidget.vue'
import DownloadBtnWidget from '@payroll/download-btn-widget/src/DownloadBtnWidget.vue'
import FileUploadWidget from '@payroll/file-upload-widget/src/FileUploadWidget.vue'
import FormWidget from '@payroll/form-widget/src/FormWidget.vue'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'
import LinkWidget from '@payroll/link-widget/src/LinkWidget.vue'
import ModalWidget from '@payroll/modal-widget/src/ModalWidget.vue'

import NumberFieldWidget from '@payroll/number-field-widget/src/NumberFieldWidget.vue'
import {UserDetailsResponse} from '@payroll/optimus-common'
import PasswordFieldWidget from '@payroll/password-field-widget/src/PasswordFieldWidget.vue'
import PerfectScrollbar from '@payroll/perfect-scrollbar-widget/src/component/PerfectScrollbar.vue'
import PhoneFieldWidget from '@payroll/phone-field-widget/src/PhoneFieldWidget.vue'
import RadioGroupWidget from '@payroll/radio-group-widget/src/RadioGroupWidget.vue'
import SearchResultsWidget from '@payroll/search-results-widget/src/component/SearchResultsWidget.vue'
import SelectFieldWidget from '@payroll/select-field-widget/src/SelectFieldWidget.vue'
import SpinnerWidget from '@payroll/spinner-widget/src/SpinnerWidget.vue'
import TextAreaWidget from '@payroll/text-area-widget/src/TextAreaWidget.vue'
import TextFieldWidget from '@payroll/text-field-widget/src/TextFieldWidget.vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import IdleVue from 'idle-vue'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import TreeView from 'vue-json-tree-view'
import VueProgressBar from 'vue-progressbar'
import {VueReCaptcha} from 'vue-recaptcha-v3'
import VueRx from 'vue-rx'
import vSelect from 'vue-select'
import ScrollBar from 'vue2-scrollbar'
import vDatePicker from 'vuejs-datepicker'
import '../src/assets/js/jquery-3.3.1.min.js'
import '../src/assets/js/jquery-migrate-1.2.1.min.js'
import '../src/assets/js/slick/slick.js'
import {messages} from './lang/heValidation'
import i18n from './lang/lang'
import router from './router'
import store from './store'

import '@/assets/js/slick/slick-theme.css'
import '@/assets/js/slick/slick.css'
import '@/assets/styles/_colors.scss'

import '@/assets/styles/_style.scss'
import '@/assets/styles/app.scss'

Vue.use(ToggleButton)

library.add(fas, far, fal, fab)
Vue.component('fa-icon', FontAwesomeIcon)

Vue.component('v-select', vSelect)
Vue.component('v-date-picker', vDatePicker)
Vue.component('scroll-bar', ScrollBar)

Vue.component('number-field-widget', NumberFieldWidget)
Vue.component('password-field-widget', PasswordFieldWidget)
Vue.component('text-field-widget', TextFieldWidget)
Vue.component('text-area-widget', TextAreaWidget)
Vue.component('checkbox-widget', CheckboxWidget)
Vue.component('link-widget', LinkWidget)
Vue.component('form-widget', FormWidget)
Vue.component('modal-widget', ModalWidget)
Vue.component('grid-widget', GridWidget)
Vue.component('spinner-widget', SpinnerWidget)
Vue.component('search-results-widget', SearchResultsWidget)
Vue.component('button-widget', ButtonWidget)
Vue.component('download-btn-widget', DownloadBtnWidget)
Vue.component('phone-field-widget', PhoneFieldWidget)
Vue.component('select-field-widget', SelectFieldWidget)
Vue.component('date-field-widget', DateFieldWidget)
Vue.component('perfect-scrollbar-widget', PerfectScrollbar)
Vue.component('file-upload-widget', FileUploadWidget)
Vue.component('radio-group-widget', RadioGroupWidget);

Vue.use(TreeView)
Vue.use(BootstrapVue)

// For more options see below
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
    useRecaptchaNet: true,
    autoHideBadge: true
})

require('@/assets/js/jquery-3.3.1.min.js')
require('@/assets/js/general.js')

/**** vee validate *****/
Vue.use(VeeValidate, {
    inject: false,
    locale: 'he',
    dictionary: {
        he: {messages: messages}
    }
})

/**** progress bar *****/
const options = {
    color: '#bffaf3',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}
Vue.use(VueProgressBar, options)

Vue.use(VueRx)

Vue.config.productionTip = false

const eventsHub = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

/**** idle plugin *****/
const vueappidletime: any = process.env.VUE_APP_IDLE_TIME
const idleTimeVar = 1000 * 60 * vueappidletime
const idleOptions = {
    idleTime: idleTimeVar, //5 minutes
    eventEmitter: eventsHub,
    events: ['keydown', 'mousedown', 'touchstart'],
    store
}
Vue.use(IdleVue, idleOptions)
/*************************/

/**** Sentry *****/
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        release: process.env.VUE_APP_SENTRY_RELEASE,
        integrations: [new Integrations.Vue({
            Vue,
            attachProps: true,
        })],
        blacklistUrls: [
            /chunk-vendors\..*\.js/,
            /https?:\/\/.*\.googletagmanager\.com\/.*/,
            /recaptcha/,
            /https?:\/\/.*\.google\.com\/.*/,
            /https?:\/\/.*\.google-analytics\.com\/.*/,
            /https?:\/\/.*\.fonts\.gstatic\.com\/.*/,
            /https?:\/\/.*\.gstatic\.com\/.*/
        ]
    })
    Sentry.configureScope((scope: any) => {
        const userDetails: UserDetailsResponse = store.getters['authentication/userDetails']
        const mngCompanyName: string = store.getters['authentication/mngCompanyName']
        scope.setUser({
            id: userDetails.idNumber || 'Unknown',
            username: userDetails.fullName || 'Unknown'
        })
        scope.setTag('managingCompany', mngCompanyName || 'Unknown')
    })
}
/*************************/